<template>
  <v-card outlined light class="rounded-md">
    <v-container style="background-color: #45e09e">
      <v-row>
        <v-col cols="auto" class="pa-6" align-self="center">
          <v-card-title
            primary-title
            style="text-align: left"
            class="pa-0"
            color="white"
          >
            <span
              style="
                font-family: Inter;
                color: white;
                font-size: 18px;
                line-height: 18px;
              "
            >
              <v-icon small color="white" style="margin-top: -3px"
                >mdi-hammer-screwdriver</v-icon
              >
              Producer
            </span>
          </v-card-title>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="pa-6 py-4">
      <v-row v-if="!!chain?.bp_name" no-gutters>
        <v-col cols="auto" class="py-1">
          <span
            style="
              font-family: Inter;
              font-size: 0.875rem;
              font-weight: 600;
              margin-right: 4px;
            "
          >
            BP Name</span
          >
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-icon
                class="grey-lighten-2"
                v-bind="attrs"
                small
                style="margin-top: -2px"
                v-on="on"
              >
                mdi-help-circle-outline
              </v-icon>
            </template>
            <span>The name of the block producer for this chain</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="auto"
          class="py-1"
          style="font-family: Inter; font-size: 0.875rem; font-weight: 400"
        >
          <span
            class="copyable-value"
            @click="copyToClipboard(chain?.bp_name, 'BP Name')"
            >{{ chain?.bp_name }}</span
          >
        </v-col>
      </v-row>
      <activity-alert
        v-for="alert in producerAlerts"
        :key="alert.key"
        :alert="alert"
        :node="node"
        @value-copied="handleValueCopied"
      />
    </v-col>
    <v-snackbar v-model="showToast" :timeout="2000" bottom>
      {{ toastMessage }}
    </v-snackbar>
  </v-card>
</template>

<script>
import ActivityAlert from './ActivityAlert.vue';

export default {
  components: {
    ActivityAlert,
  },
  props: {
    node: {
      type: Object,
      default() {
        return {};
      },
    },
    chain: {
      type: Object,
      default() {
        return {};
      },
    },
    producerAlerts: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      showToast: false,
      toastMessage: '',
    };
  },
  methods: {
    copyToClipboard(text, fieldName) {
      if (!text) return;
      navigator.clipboard
        .writeText(text.toString())
        .then(() => {
          this.toastMessage = `${fieldName} copied to clipboard`;
          this.showToast = true;
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    },
    handleValueCopied(message) {
      this.toastMessage = message;
      this.showToast = true;
    },
  },
};
</script>

<style></style>
